<div>
  <div class="now-empty-state">
    <div class="d-flex align-content-center flex-column flex-wrap now-body-large">
      <div class="mx-auto" [ngClass]="(mobileView$ | async) ? 'w-75' : 'w-50 px-5'">
        Bitte geben Sie einen <b>Suchbegriff</b> ein, um passende Angebote zu erhalten.
      </div>
      <div class="now-suche-illustration-container">
        <img ngSrc="assets/images/NOW_Illustration_Suche.svg" fill alt="" priority />
      </div>

      @if (libConfig.showThemenfelder) {
        <div class="mx-auto mb-2" [ngClass]="(mobileView$ | async) ? 'w-75' : 'w-50 px-5'">
          Nicht sicher, wonach Sie suchen sollen? Nutzen Sie die <b>Themenfelder</b> um die passende
          Suche zu starten.
        </div>
        <button
          (click)="navigateToThemenfelder()"
          type="button"
          class="now-btn now-btn-secondary mx-auto"
        >
          Nach Themenfeldern suchen
        </button>
      }
    </div>
  </div>
</div>
